import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';

import {  useHistory } from 'react-router-dom';
import 'moment/locale/es';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

//Components
import Loading from '../components/Loading';
import FormErrors,{ trowError } from '../components/FormErrors';
import { TableStyled } from '../components/TableStyled';

// Models
import AcreditacionProfile from '../models/AcreditacionProfile';
import { LIST_GASTRONOMIC_GUIDE, GENERATE_GASTRONOMIC_GUIDE_PDF, QUERY_LIST_GASTRONOMIC_GUIDE_VISITS } from '../models/GuiaGastronomica';


import { textAreaStyle } from '../styles/includes/forms'



const StyledPage = styled.main`
  padding: 2rem;
  .event-wrapper {
    & > * {
      &:not(:last-child) {
        border-bottom: 1px solid var(--color-gray-light);
      }
    }
  }
  .status-info-wrapper {
    margin-top: 2rem;
  }
`

const Center = styled.p`
  text-align:center;
`;


const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h2 {
    margin: 1.5rem 0;
  }
  h3 {
    margin: 1.3rem 0;
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .field {
    margin-bottom: 1rem;
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`;

const TableStyledComplement= styled(TableStyled)`
  table thead th:nth-child(even){
    background-color: var(--color-azul) !important;
  }
 table tbody tr{
    border-bottom:1px solid var(--color-azul);
      &:nth-child(odd){
        & td:nth-child(odd), & td:nth-child(even){
            background-color:#ffffff;
        } 
      }
      &:nth-child(even){
        & td:nth-child(odd), & td:nth-child(even){
            background-color:#ffffff;
        }
      }
 }

  .logo{
    display: grid;
    grid-template-columns: 70px auto;
    gap: 20px;
    font-weight: bold;
    .image{
        text-align: center;
        img{
          height: 35px;
        }
    }
  }
  .btn{
    width: 100%;
    button{
      padding: 7px 14px !important;
      font-weight: bold;
    }
  }
  
`;


export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();

    const { params } = useRouteMatch();

    const [submitError,setSubmitError] = useState<null|string>(null);
    const [loading,setLoading] = useState(true);
    const [conten,setContent] = useState('');

    
    const { loading:loadingGastronomic, error:errorGastronimic, data:dataGastronomic } = useQuery(LIST_GASTRONOMIC_GUIDE,{
        variables:{
            'first':50,
            'page':0,
            'profile_uuid':UserInfo.uuid,  
        },
        context:{
            clientName:'SITE'
        }
    });

    const { loading:loadingGastronomicVisit, error:errorGastronimicVisit, data:dataGastronomicVisit } = useQuery(QUERY_LIST_GASTRONOMIC_GUIDE_VISITS,{
        variables:{
            'profile_uuid':UserInfo.uuid,  
        },
    });    


    useEffect(() => {
        ( async () =>{
            setSubmitError(null);
            setLoading(true);
      
            try{
                let response= await fetch('https://www.atleticodesanluis.mx/webservices/get_content/guia_gastronomica');
                let responseJson=await response.json();

                setContent(responseJson.conten);
            }catch(e){
                setSubmitError(e.message);
            }finally{
                setLoading(false);
            }
        })();
    },[]);

    if(loading || loadingGastronomic || loadingGastronomicVisit)
        return <Loading />

    

    const BtnGuiaGastronomicaDownloadPdf= ({ item }:{item:any}) => {
        const [ generatePdf, { loading } ] = useMutation(GENERATE_GASTRONOMIC_GUIDE_PDF);
        const [link,setLink] = useState<string|null>(null);
        const submit=async () => {
            try{
                const response=await generatePdf({
                    variables:{
                        profile_uuid:UserInfo.uuid,
                        gastronomic_guide_id:+item.id
                    }
                });


                if(response.errors)
                    throw new trowError(response.errors);            
                
                setLink(response?.data?.generateGastronomicGuidePdf?.url);

            }catch(e){
                setSubmitError(e.message);

                alert(e.message);
            }
        };

        if(link) return (<button  type="button"  className="bg-red" onClick={ () => window.open(link)}>Descargar QR</button>);
        else return (<button  type="button"  className="bg-azul" onClick={submit} disabled={loading}>Generar QR</button>);
    };

    console.log({
        dataGastronomic,
        dataGastronomicVisit,
    })

    return (
        <StyledPage>
            {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
            <StyledForm>
                <div dangerouslySetInnerHTML={{ __html: conten}} />
                <br />
                <div>

                    <TableStyledComplement className="col-12 mt-5">
                        <div className="tit-table">MI PASAPORTE CANIRAC</div>
                        <table className="table-formate">
                            <thead>
                                <tr>
                                    <th>Restaurante</th>
                                    <th className="text-center">Visitas</th>
                                    <th className="text-center">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataGastronomic?.allGastronomicGuide?.data?.filter( item =>  item.is_passaporte_canirac)?.map(item => {
                                    const itemSelected=dataGastronomicVisit?.listGastronomicGuideVisits?.filter(itemVisit => item.id==itemVisit.gastronomic_guide_id)?.[0];
                                    return (
                                        <tr>
                                            <td className='logo'>
                                                <span className='image'><img src={item.logo_path_url} /></span>
                                                <span className='text'>{item.nombre}</span>
                                            </td>
                                            <td className="text-center">{itemSelected?.total || 0}</td>
                                            <td className="btn text-center">
                                                <BtnGuiaGastronomicaDownloadPdf item={item}  />
                                            </td>
                                        </tr>
                                    )
                                }
                                )}
                            </tbody>
                        </table>
                    </TableStyledComplement>


                </div>
            </StyledForm>
        </StyledPage>
    )
}

